import React, { useState } from 'react'
import { Star } from 'lucide-react'

// Sao đánh giá: chế độ hiển thị (mặc định) hoặc chấm điểm (truyền onRate).
const StarRating: React.FC<{
  value: number
  count?: number
  size?: number
  onRate?: (stars: number) => void
}> = ({ value, count, size = 16, onRate }) => {
  const [hover, setHover] = useState(0)
  const shown = hover || value
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          className={i <= Math.round(shown) ? 'text-amber-400 fill-amber-400' : 'text-gray-300'}
          style={onRate ? { cursor: 'pointer' } : undefined}
          onMouseEnter={onRate ? () => setHover(i) : undefined}
          onMouseLeave={onRate ? () => setHover(0) : undefined}
          onClick={onRate ? () => onRate(i) : undefined}
        />
      ))}
      {count != null && (
        <span className="text-xs text-gray-500 ml-1">
          {value > 0 ? value.toFixed(1) : 'Chưa có'}{count > 0 ? ` (${count})` : ''}
        </span>
      )}
    </div>
  )
}

export default StarRating
